// Components==============
import { useMutation, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
// =========================

type RequestType = Partial<UserEntity>;

const createUser = (data: RequestType) =>
  axios.post("/api/user", data).then((r) => r.data);

export default function useCreateUser() {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: createUser,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["user"] });
    },
    onError: (error) => {
      console.error("Error creating user:", error);
    },
  });

  return mutation;
}
